import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Header } from "semantic-ui-react";
import { RawHTML, LineBreaks } from "../common";
import styles from "./styles.less";

class AddonDetails extends Component {
  render() {
    const { name, description, isRtl } = this.props;
    const textAlign = isRtl ? "right" : "left";
    return (
      <Grid
        textAlign={textAlign}
        className={cx(styles.details, { [styles.rtl]: isRtl })}
      >
        <Grid.Column width={16}>
          <Header inverted as="h3" content={name} className={styles.name} />
          <LineBreaks>
            <RawHTML html={description} className={styles.description} />
          </LineBreaks>
        </Grid.Column>
      </Grid>
    );
  }
}

AddonDetails.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  isRtl: PropTypes.bool
};

export default AddonDetails;



// WEBPACK FOOTER //
// ./src/components/AddonDetails/AddonDetails.js